// 이미지 짱많, 유튜브 영상
// 푸터 위에contact 구역 있음, 오른쪽에 contact 픽스 있음,
// 하단에 form 픽스, 신청하기 , 푸터
// formFieldColor="white" (이름&번호 input 배경 흰색)
// 질문 2개 - 이름 & 번호, 치료종류(select)
// 특이사항 - form 하단에 픽스스

import React, { useEffect, useRef, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  dentalOptions,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import ImageSlider from "../components/ImageSlider";
import PrivacyContent from "./PrivacyContent";

function RandingStyle15({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img7Path,
  img8Path,
  img9Path,
  img10Path,
  img11Path,
  img12Path,
  img13Path,
  img14Path,
  img15Path,
  img16Path,
  scrollBtn1,
  scrollBtn2,
  formFieldColor,
  privacyMessage,
  slider1Path,
  slider2Path,
  slider3Path,
  keepBTN,
  postBTN,
  companyName,
  callNumber,
  kakaoLink,
  footerPath,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  eventDates,
  treatments,
  treatmentQ,
  treatmentsImg,
  adTarget,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (event) => {
    const newOption = event.target.value;
    setSelectedOption(newOption); // 상태 업데이트

    // 상태 업데이트 후 바로 새로운 값을 확인하려면 이곳에서 처리
    console.log(newOption); // 바로 선택된 값을 찍을 수 있음
  };

  const handleSelectEvent = (option) => {
    setSelectedValue(option);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    // selectedValue가 빈 값일 경우 treatments의 첫 번째 value로 설정
    const finalSelectedValue =
      selectedValue && selectedValue !== ""
        ? selectedValue
        : treatments && treatments.length > 0
        ? treatments[0].value
        : null; // treatments가 비어 있는 경우 null

    // finalSelectedValue가 객체인 경우 value 추출
    if (
      finalSelectedValue &&
      typeof finalSelectedValue === "object" &&
      finalSelectedValue.value
    ) {
      finalSelectedValue = finalSelectedValue.value;
    }

    if (treatments && !finalSelectedValue) {
      console.error("선택 가능한 값이 없습니다.");
      return; // treatments가 비어 있는 경우 처리
    }

    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      selectedValue: finalSelectedValue, // 업데이트된 selectedValue 전달
      kakaotalk,
      carrotTag,
    });
  };

  const scrollRefs = useRef({}); // 대상 요소들을 저장할 ref 객체

  // ref 등록 함수
  const registerRef = (id) => (element) => {
    if (element) scrollRefs.current[id] = element;
  };

  // 스크롤 함수
  const handleScrollToElement = (targetId) => {
    const targetElement = scrollRefs.current[targetId];
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div
      className="form-container"
      style={{ paddingBottom: "clamp(260px, 40%, 420px)" }}
    >
      <div className="step2">
        {img1Path && (
          <a href={callNumber}>
            <img src={img1Path} alt="임플란트 고민중이세요?" />
          </a>
        )}

        <div className="scrollBtnBox">
          {scrollBtn1 && (
            <img
              src={scrollBtn1[0]}
              alt="스크롤 버튼 1"
              onClick={() => handleScrollToElement(scrollBtn1[1])} // img4로 스크롤
            />
          )}
          {scrollBtn2 && (
            <img
              src={scrollBtn2[0]}
              alt="스크롤 버튼 2"
              onClick={() => handleScrollToElement(scrollBtn2[1])} // img4로 스크롤
            />
          )}{" "}
        </div>

        {img2Path && <img src={img2Path} alt="임플란트 고민중이세요?" />}
        {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
        {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}

        {slider1Path && (
          <ImageSlider
            images={slider1Path} // 경로 동적 할당
          />
        )}

        {img5Path && (
          <img
            id="img5Path"
            ref={registerRef("img5Path")}
            src={img5Path}
            alt="임플란트 고민중이세요?"
          />
        )}

        {img6Path && <img src={img6Path} alt="임플란트 고민중이세요?" />}
        {img7Path && <img src={img7Path} alt="임플란트 고민중이세요?" />}
        {slider2Path && (
          <ImageSlider
            images={slider2Path} // 경로 동적 할당
          />
        )}
        {img8Path && <img src={img8Path} alt="임플란트 고민중이세요?" />}
        {img9Path && (
          <img
            id="img9Path"
            ref={registerRef("img9Path")}
            src={img9Path}
            alt="임플란트 고민중이세요?"
          />
        )}
        {img10Path && <img src={img10Path} alt="임플란트 고민중이세요?" />}
        {img11Path && <img src={img11Path} alt="임플란트 고민중이세요?" />}
        {img12Path && <img src={img12Path} alt="임플란트 고민중이세요?" />}
        {img13Path && <img src={img13Path} alt="임플란트 고민중이세요?" />}
        {img14Path && <img src={img14Path} alt="임플란트 고민중이세요?" />}
        {img15Path && <img src={img15Path} alt="임플란트 고민중이세요?" />}
        {img16Path && <img src={img16Path} alt="임플란트 고민중이세요?" />}

        <div className="qBox fixed2">
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {treatments && (
            <div className="selectEventBox">
              {treatmentQ && (
                <img src={treatmentQ} alt="임플란트 고민중이세요?" />
              )}
              <div className="selectEvents">
                {treatments.map((option, index) => (
                  <img
                    style={{ width: `${100 / treatments.length}%` }}
                    key={index} // index 값 사용
                    src={`${treatmentsImg}/${
                      selectedValue === option.value
                        ? `option${index + 1}(1)`
                        : `option${index + 1}`
                    }.png`}
                    alt={option.value}
                    onClick={() => handleSelectEvent(option.value)}
                  />
                ))}
              </div>
            </div>
          )}
          <p className="benefitInfo">
            <BenefitPeriod />
            <br />
            이벤트 대상자 : 해당 매체 이용자
          </p>
          <form
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div className="formFieldBox">
              <div className={`formField`}>
                {treatments ? "" : <label htmlFor="name">이름</label>}

                <input
                  type="text"
                  id="name"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={treatments ? "성함" : "성함을 입력해주세요."}
                  className="nameInput"
                />
              </div>
              <PhoneNumberInput
                phoneNumber={phoneNumber}
                phoneFirstOptions={phoneFirstOptions}
                handlePhoneNumberChange={handlePhoneNumberChange}
                formFieldColor={formFieldColor}
                treatments={treatments}
              />
            </div>
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={companyName} />
                </div>
              </div>
            )}
            {/* <p className="benefitInfo">
              <BenefitPeriod />
              <br />
              이벤트 대상자 : {adTarget || "해당 매체 이용자"}
            </p> */}
          </form>
        </div>
      </div>

      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle15;
